// extracted by mini-css-extract-plugin
module.exports = {"info":"styles_info__Eem76","images_wrap":"styles_images_wrap__WLCc7","main":"styles_main__2a6HN"};